export default __webpack_public_path__ + "static/media/img_vision_01_m.012ccac1.png";